/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.grading-periods'},
});

const GradingPeriodsItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/grading-periods"
    title={messages.title}
  />
);

export default GradingPeriodsItem;
